<template>
    <div class="full-content">
        <div class="res-title">
            <img src="@/assets/images/bigData/top_bg.png" alt="">
            <h4>绩溪市党建数据平台</h4>
        </div>
        <div class="main">
            <!--          左侧-->
            <div class="left-main-position">
                <div class="left-main">
                    <!-- 四角拐角 -->
                    <div class="top-left"></div>
                    <div class="top-right"></div>
                    <div class="bottom-left"></div>
                    <div class="bottom-right"></div>
                    <div class="Pyramid">
                        <p class="Pyramid-title" style="margin: 25px 0; text-align: left; ">党组织基本架构</p>
                        <div class="mid-Pyramid">
                            <div class="left-mid-title">社区党支部</div>
                            <div class="left-mid-num"><span id="StreetPublicCommittee">{{danggongwei}}</span>个</div>
                        </div>
                        <div class="footer-Pyramid">
                            <div class="title1">
                                社区党总支 <span id="GridPy12">{{ dangzongzhi }}</span><span>个</span>
                            </div>
                            <div class="title2">
                                社区党支部 <span id="CommunityPY">{{ danggongwei }}</span><span>个</span>
                            </div>
                            
                            <div class="title3">
                                党小组 <span id="buildingPy">{{ dangzhibu }}</span><span>个</span>
                            </div>
                            <div class="title4">
                                党员 <span id="PartyMemberCenter">{{dangyuan}}</span><span>个</span>
                            </div>
                            <!--                          <div class="title5">10名党员</div>-->

                        </div>

                    </div>
                    <div class="Party-organization-construction">
                        <div class="Party-organization-title">
                            党员缴费情况
                        </div>
                        <div class="Party-organization-content" style="height: 170px;">
                            <div id="dangzuzhi"
                                 style="width: 370px; height: 170px; -webkit-tap-highlight-color: transparent; user-select: none; position: relative;">

                            </div>

                        </div>
                    </div>
                    <div class="party-serve">
                        <div class="party-serve-title">
                            党群服务中心
                        </div>
                        <div class="serve-party-tab">
                            <div class="tab-conten">
                                <div class="header tab-h">
                                    <div class="header-left-title">社区</div>
                                    <div class="header-right-title">党群服务中心</div>
                                </div>
                                <div class="header-body-content" id="leftListTitle">
                                    <div class="heabody tab-h" v-for="(item,index) in partyService" :key="index">
                                        <div class="headerbody-left">{{item.name}}</div>
                                        <div class="headerbody-right">{{item.total}}个</div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <ul class="left-right-small-btn">
                <li>
                    <span id="dzz">{{dangzongzhi}}</span>
                    <p>社区党总支</p>
                </li>
                <li>
                    <span>{{dangyuan}}</span>
                    <p>党员人数</p>
                </li>
                <!--                <li>-->
                <!--                    <span>10</span>-->
                <!--                    <p>优秀党支部</p>-->
                <!--                </li>-->
                <!--                <li>-->
                <!--                    <span>20</span>-->
                <!--                    <p>优秀党员</p>-->
                <!--                </li>-->
            </ul>
            <!--          地图-->
            <div class="mid-top">
                <!-- <bmap @ck="ck" @cks="cks" @ckID="ckID"></bmap> -->
                <bmap @cks="cks" @setOrgId="setOrgId" @getOrgName="getOrgName" @getDangWerShuJi="getDangWerShuJi"></bmap>
            </div>


            <!--          右侧-->
            <div class="right-main-position">
                <div class="right-main">


                    <!-- 四角拐角 -->
                    <div class="top-left"></div>
                    <div class="top-right"></div>
                    <div class="bottom-left"></div>
                    <div class="bottom-right"></div>

                    <div class="right-top">
                        <div class="right-top-title">
                            社区累计活动量
                        </div>
                        <div class="activity-content">
                            <div class="activity-item">
                                <div class="activity-left">
                                    <img src="../../../assets/images/bigData/silianhuodong_icon.png" alt="" srcset="">
                                </div>
                                <div class="activity-right">
                                    <div class="activity-right-top"><span id="Quadruple">{{activityObj.leave}}</span>次
                                    </div>
                                    <div class="activity-right-bot">党员学习</div>
                                </div>
                            </div>
                            <div class="activity-item">
                                <div class="activity-left">
                                    <img src="../../../assets/images/bigData/sanhuiyike_icon (2).png" alt="" srcset="">
                                </div>
                                <div class="activity-right">
                                    <div class="activity-right-top"><span
                                            id="ThreeSessions">{{activityObj.activly}}</span>次
                                    </div>
                                    <div class="activity-right-bot">工作计划</div>
                                </div>
                            </div>
                            <div class="activity-item">
                                <div class="activity-left">
                                    <img src="../../../assets/images/bigData/sirihuodong_icon.png" alt="" srcset="">
                                </div>
                                <div class="activity-right">
                                    <div class="activity-right-top"><span id="FourDay">{{activityObj.commun}}</span>次
                                    </div>
                                    <div class="activity-right-bot">党组织活动</div>
                                </div>
                            </div>
                            <div class="activity-item">
                                <div class="activity-left">
                                    <img src="../../../assets/images/bigData/dangyuanjiaoyu_icon.png" alt="" srcset="">
                                </div>
                                <div class="activity-right">
                                    <div class="activity-right-top"><span id="Education">{{activityObj.service}}</span>次
                                    </div>
                                    <div class="activity-right-bot">志愿者服务</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="right-mid">
                        <div class="right-mid-title shuxian">党员</div>
                        <Echart/>
                    </div>
                    <div class="right-bot">
                        <div class="bot-title-positive shuxian">
                            党员积极分子和发展对象
                        </div>
                        <div class="positive-tab">

                            <table width="340" id="tab-positive">
                                <thead>
                                <tr height="32" bgcolor="#3352A1">
                                    <th align="center">社区名称</th>
                                    <th align="center">积极分子</th>
                                    <th align="center">发展对象</th>
                                </tr>
                                </thead>

                                <tbody id="tbody2">
                                <tr height="32" v-for="(item,index) in target" :key="index">
                                    <td align="center">{{item.name}}</td>
                                    <td align="center">{{item.activist}}</td>
                                    <td align="center">{{item.target}}</td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!--          弹窗-->
        <div class="Max-alter-content" v-show="win">
            <div class="Max-alter active">
                <div class="left-top-bg bgw">
                </div>
                <div class="right-top-bg bgw"></div>
                <div class="left-bot-bg bgw"></div>
                <div class="right-bot-bg bgw"></div>

                <div class="clear-alter-box" @click="win=false">
                    <img src="../../../assets/images/bigData/guanbi_icon.png" alt="" srcset="">
                </div>
                <div class="party-branch">
                    <div class="party-header1">
                        <div class="party-header1-title">{{orgName1}}</div>
                    </div>
                    <div class="party-content-wrap">
                        <div class="top-content-wrap">
                            <div class="organizational-structure">
                                <div class="header1">
                                    <img src="../../../assets/images/bigData/zuzhi_icon.png" alt="">
                                    <div class="header1-title">组织架构</div>
                                </div>
                                <div class="content-wrap" id="organizationalStructure">
                                    <div class="content-box">

                                        <div class="left-peo">
                                            <!-- <img src="http://58.243.183.70:8082\9f4a0af1c9cc4ad3a29d77bfcd089871.jpg"
                                                 alt="" srcset=""> -->
                                                 <img :src="linkImage"
                                                 alt="" srcset="">
                                            <div class="peo-information">
                                                <div class="zhiwei">{{dangWei}}书记</div>
                                                <div class="name-peo">{{leaderName}}</div>
                                                <!-- <div class="tel-peo">{{linkPhone}}</div> -->
                                            </div>
                                        </div>
                                        <div class="right-content-list">
                                            <div class="item-c-r">
                                                <div class="l-img">
                                                    <img src="../../../assets/images/bigData/dangyuanrenshu_icon.png"
                                                         alt="">
                                                </div>
                                                <div class="l-info">
                                                    <div class="info-num"><span>{{dangyuanNum}}</span>人</div>
                                                    <div class="info-text">党员人数</div>
                                                </div>
                                            </div>
                                            <div class="item-c-r">
                                                <div class="l-img">
                                                    <img src="../../../assets/images/bigData/dangyuanzhiyuanzhe_icon.png"
                                                         alt="">
                                                </div>
                                                <div class="l-info">
                                                    <div class="info-num"><span>{{zyzNum}}</span>人</div>
                                                    <div class="info-text">党员志愿者</div>
                                                </div>
                                            </div>
                                            <div class="item-c-r" style="margin: 0;">
                                                <div class="l-img">
                                                    <img src="../../../assets/images/bigData/dangweijuwei_icon.png"
                                                         alt="">
                                                </div>
                                                <div class="l-info">
                                                    <div class="info-num"><span>{{jwhNum}}</span>人</div>
                                                    <div class="info-text">党员+居委会成员（一肩挑）</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="mid-org-str">
                                <div class="header1">
                                    <img src="../../../assets/images/bigData/jihua_icon.png" alt="">
                                    <div class="header1-title">本月工作计划</div>
                                </div>
                                <div class="content-wrap" id="WorkPlan">
                                    <div class="p11">
                                        <p style="color: #8fbff2;">{{workPlan.planTitle}}</p>
                                        <p style="color: #8fbff2;text-indent:32px;">{{workPlan.planContent}}</p>
                                       <!-- 01、党建工作:1、开展非公企业和社会组织摸底调查工作，完善非公党建平台，在非公组织中开展“找党员、建组织”专项行动。 -->
<!--                                        2、梳理网格化平台组织建设内容。-->
<!--                                        3、远创集团党支部整建制转出相关工作。-->
<!--                                        4、召开非公党建指导员工作例会。-->
<!--                                        5、开展党员党费缴纳核算工作。-->
<!--                                        6、做好社区优化调整相关工作。-->
<!--                                        ①社区党组织书记备案；-->
<!--                                        ②调整的党委委员补选；-->
<!--                                        ③远教站点、先锋网站的报备和调整；-->
<!--                                        ④党员划转； ⑤党建软件材料、党费交接；-->
<!--                                        ⑥非公党建平台调整，党建指导员与社区对接。-->
                                    </div>
                                    <!-- <div class="p11"> -->
                                       <!-- 02、宣传思想工作：1、信息报送。 2、舆情信息直报，每周1篇，各社区轮流报送，具体顺序 长淮社区；火车站社区；临泉路社区；胜利社区；元一社区。 -->
<!--                                        3、调整宣传信息员队伍。-->
                                    <!-- </div> -->
                                    <!-- <div class="p11"> -->
<!--                                        03、综合性工作：1、组织开展街道述职述德述廉会议，做好准备工作。-->
<!--                                        2、制作市派区派下沉党员干部战“疫”动感影集。-->
<!--                                        3、调整宗教信息员队伍。-->
                                    <!-- </div> -->
                                </div>
                            </div>
                            <div class="right-org-str">
                                <div class="header1">
                                    <img src="../../../assets/images/bigData/xueli_icon.png" alt="">
                                    <div class="header1-title">学历分布</div>
                                </div>
                                <div class="content-wrap" id="xueLiId"
                                     style="-webkit-tap-highlight-color: transparent; user-select: none; position: relative;">

                                </div>
                            </div>
                        </div>

                        <div class="top-content-wrap">
                            <div class="organizational-structure">
                                <div class="header1">
                                    <img src="../../../assets/images/bigData/dangyuanhuodong_icon.png" alt="">
                                    <div class="header1-title">其他党员活动</div>
                                </div>
                                <div class="content-wrap1">
                                    <table width="100%" id="tab-positive1">
                                        <thead>
                                        <tr height="42" bgcolor="#3352A1">
                                            <th align="center">活动名称</th>
                                            <th align="center">时间</th>
                                            <th align="center">参与组织</th>
                                        </tr>
                                        </thead>

                                        <tbody id="tbody111">
                                        <tr height="42" v-for="(item,index) in hdList" :key="index">
                                            <td title="学习施永康先进事迹" align="center">{{item.name}}</td>
                                            <td align="center">{{item.createDate.split(' ')[0]}}</td>
                                            <td align="center">{{item.orgName}}</td>
                                        </tr>
                                        </tbody>
                                    </table>

                                </div>
                            </div>
                            <!--                        <div class="mid-org-str">-->
                            <!--                            <div class="header1">-->
                            <!--                                <img src="./src/img/party/zhichengfenbu_icon.png" alt="">-->
                            <!--                                <div class="header1-title">职称分布</div>-->
                            <!--                            </div>-->
                            <!--                            <div class="content-wrap" style="height: 220px;width: 380px;  overflow: hidden;"-->
                            <!--                                 id="zhichengId">-->
                            <!--                            </div>-->
                            <!--                            <div class="f-wrap">-->
                            <!--                                <div class="text-xueli-rank" id="TextzhiId">-->

                            <!--                                </div>-->
                            <!--                            </div>-->
                            <!--                        </div>-->
                            <div class="right-org-str">
                                <div class="header1">
                                    <img src="../../../assets/images/bigData/dangling_icon.png" alt="">
                                    <div class="header1-title">党龄分布</div>
                                </div>
                                <div class="content-wrap" id="danglFB">

                                </div>
                            </div>
                        </div>

                        <div class="footer-content-bot">
                            <div class="footer-content-botL">
                                <div class="header1">
                                    <img src="../../../assets/images/bigData/sanhuiyike_icon (3).png" alt="">
                                    <div class="header1-title">三会一课完成情况</div>
                                </div>
                                <div class="footer-content-wrap" id="lessonCompletionStatus">
                                    <div class="item-box">
                                        <div class="top-info">
                                            支部党员大会
                                        </div>
                                        <div class="bot-num">
                                            <div class="left-user-num"><span>{{Lesson.dh}}</span>/</div>
                                            <div class="right-end-num">{{Lesson.dhAll}}</div>
                                        </div>
                                    </div>
                                    <div class="item-box">
                                        <div class="top-info">
                                            支部委员会
                                        </div>
                                        <div class="bot-num">
                                            <div class="left-user-num"><span>{{Lesson.wyh}}</span>/</div>
                                            <div class="right-end-num">{{Lesson.wyhAll}}</div>
                                        </div>
                                    </div>
                                    <div class="item-box">
                                        <div class="top-info">
                                            党小组会议
                                        </div>
                                        <div class="bot-num">
                                            <div class="left-user-num"><span>{{Lesson.dxz}}</span>/</div>
                                            <div class="right-end-num">{{Lesson.dxzAll}}</div>
                                        </div>
                                    </div>
                                    <div class="item-box">
                                        <div class="top-info">
                                            党课
                                        </div>
                                        <div class="bot-num">
                                            <div class="left-user-num"><span>{{Lesson.dk}}</span>/</div>
                                            <div class="right-end-num">{{Lesson.dkAll}}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="footer-content-botR">
                                <div class="header1">
                                    <img src="../../../assets/images/bigData/bangfu_icon.png" alt="">
                                    <div class="header1-title">重点帮扶对象</div>
                                </div>
                                <div class="peo-list" id="helpObject">
                                    <div class="peo1-list" v-for="(item,index) in assistList" :key="index">
                                        <div class="tet">
                                            {{item.name}}
                                        </div>
                                        <div class="tet-num">
                                            <span>{{item.total}}</span>人
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!--      <img style="width:100%;" :src="tp1" alt="">-->
        <!--      <div class="div2" @click="clc"> </div>-->
        <!--      <img class="img2" v-show="off" :src="tp2" alt="">-->
        <!--      <div class="div3" @click="off = false;"> </div>-->
    </div>
</template>
<script>
    import AMap from "AMap"; // 引入高德地图
    import bmap from "./dangjiantest.vue";//页面原来的地图
    // import bmap from "./dataCentreindextest.vue";
    import Echart from "./Echart";
    import dataArr from "./data";
    import {post} from "@/api/requrestHttp";

    export default {
        components: {bmap, Echart},
        data() {
            return {
                leaderName: '',
                dangWei: '',
                linkPhone: '',
                linkImage: '',
                planTitle: '',
                workPlan: [],
                planContent: '',
                tp1: require('@/assets/images/dj1.jpg'),
                tp2: require('@/assets/images/bigData/bgColor.png'),
                off: false,
                win: false,
                dataArr: [
                    [
                        {name: "A类", value: 10},
                        {name: "B类", value: 47},
                        {name: "C类", value: 2}
                    ],
                    [
                        {name: "18-30岁", value: 50},
                        {name: "30-40岁", value: 150},
                        {name: "40-50岁", value: 250},
                        {name: "50-60岁", value: 350},
                        {name: "60-80岁", value: 450},
                        {name: "80岁以上", value: 500}
                    ],

                    [
                        {name: "小学以下", value: 10},
                        {name: "高中", value: 20},
                        {name: "专科", value: 30},
                        {name: "本科", value: 40},
                        {name: "硕士以上", value: 50}
                    ],
                    [
                        {name: "1年", value: 15},
                        {name: "2年", value: 25},
                        {name: "3年", value: 35},
                        {name: "4年", value: 60},
                        {name: "5年", value: 15}
                    ],
                    [
                        {name: '小学', value: 50},
                        {name: '初中', value: 30},
                        {name: '高中及中专', value: 70},
                        {name: '大专', value: 70},
                        {name: '本科', value: 60},
                    ]
                ],
                xueliList: [],
                hdList: [],
                dangyuanNum: '',
                zyzNum: 0,
                jwhNum: 0,
                Lesson: {
                    dh: "0",
                    dhAll: "0",
                    wyh: "0",
                    wyhAll: "0",
                    dxz: "0",
                    dxzAll: "0",
                    dk: "0",
                    dkAll: "0",
                },
                assistList: [],
                payArr: [],
                activityObj: {
                    leave: '',
                    activly: '',
                    commun: '',
                    service: ''
                },
                target: [],
                dangyuan: '',
                shuliang: '',
                danggongwei: '',
                dangzongzhi: '',
                dangzhibu: '',
                partyService: [],
                orgName1: '',
                zhiBuId: ''
            };
        },
        mounted() {
            // this.drawLine(0);
            // this.MapInfor();
            //    获取数据
            this.getActivity();
            this.getActivistAndTarget();
            this.getPartyService();
            this.getPartyPay();
            this.getOrganization();

        },
        methods: {
             setOrgId(id) {
                this.gridCode=id;
                this.getStatistics();
            },
            //数据获取
            //街道累计活动量
            getActivity() {
                post("/admin/statistics/info/activity", {}).then(res => {
                    if (res.code == 200) {
                        res.content.forEach(item => {
                            if (item.name == '党员学习') {
                                this.activityObj.leave = item.total;
                            }
                            if (item.name == '党组织活动') {
                                this.activityObj.commun = item.total;
                            }
                            if (item.name == '工作计划') {
                                this.activityObj.activly = item.total;
                            }
                            if (item.name == '志愿者服务') {
                                this.activityObj.service = item.total;
                            }
                        })
                        // this.modelTable = res.content
                    } else {
                        this.$message.error(res.message);
                    }
                });
            },
            //党员积极分子和发展对象
            getActivistAndTarget() {
                post("/admin/statistics/info/activistAndTarget", {}).then(res => {
                    if (res.code == 200) {
                        this.target = res.content;
                        // this.modelTable = res.content
                    } else {
                        this.$message.error(res.message);
                    }
                });
            },
            //党群服务中心
            getPartyService() {
                post("/admin/statistics/info/partyService", {}).then(res => {
                    if (res.code == 200) {
                        if (res.content.length > 4) {
                            res.content.splice(4);
                        }

                        this.partyService = res.content;
                        // this.modelTable = res.content
                    } else {
                        this.$message.error(res.message);
                    }
                });
            },
            //党员缴费情况
            getPartyPay() {
                post("/admin/statistics/info/partyPay", {}).then(res => {
                    if (res.code == 200) {
                        const that = this;
                        res.content.forEach(item => {
                            let obj = {
                                name: item.name, value: item.total
                            }
                            that.payArr.push(obj);
                        })

                        let myChart = that.$echarts.init(document.getElementById("dangzuzhi"));
                        // 绘制图表
                        myChart.setOption(that.handleOption(that.payArr));
                        // this.modelTable = res.content
                    } else {
                        this.$message.error(res.message);
                    }
                });
            },
            //党组织基本架构
            getOrganization() {
                post("/admin/statistics/info/partyOrganization", {}).then(res => {
                    if (res.code == 200) {
                        const that = this;
                        res.content.forEach(item => {
                            if(item.name=='党员'){
                                this.dangyuan=item.total;
                            }
                            if(item.name=='党组织数量'){
                                this.shuliang=item.total;
                            }
                            if(item.name=='社区党总支'){
                                this.dangzongzhi=item.total;
                            }
                            if(item.name=='社区党支部'){
                                this.danggongwei=item.total;
                            }
                            if(item.name=='党小组'){
                                this.dangzhibu=item.total;
                            }
                        })


                    } else {
                        this.$message.error(res.message);
                    }
                });
            },
            //学历分布统计
            getEducation() {
                post("/admin/statistics/info/educationStatistics", {
                    orgIds: this.wgID
                }).then(res => {
                    if (res.code == 200) {
                        this.xueliList=[];
                        if (res.content) {
                            res.content.forEach(item => {
                                let obj = {
                                    name: item.name, value: item.total
                                }
                                this.xueliList.push(obj)
                            });
                            this.xueliLine();
                        }
                    } else {
                        this.$message.error(res.message);
                    }
                });
            },
            getDangWerShuJi(id) {
                console.log("11"+id)
                post("/admin/partyOrgBuild/info/secretary", {
                    id: id
                }).then(res => {
                    console.log(res)
                    if (res.code == 200) {
                        if (res.content) {
                            // this.linkPhone = res.content.linkPhone;
                            if(res.content.leaders.length == 0){
                                this.linkImage = '';
                                this.leaderName = '';
                            }else {
                                this.linkImage = res.content.leaders[0].photo;
                                this.leaderName = res.content.leaders[0].leaderName;
                                
                            }
                            if (res.content.orgType=='1'){
                                this.dangWei =  "党委"
                            }else if (res.content.orgType=='2'){
                                this.dangWei =  "党总支"
                            }else if (res.content.orgType=='3'){
                                this.dangWei =  "党支部"
                            }else if (res.content.orgType=='4'){
                                this.dangWei =  "党小组"
                            }else if (res.content.orgType=='5'){
                                this.dangWei =  "党工委"
                            }else if (res.content.orgType==null){
                                this.dangWei =  ""
                            }
                        }
                    } else {
                        this.$message.error(res.message);
                    }
                });
            },
            //党龄分布统计
            getPartyAgeStatistics() {
                post("/admin/statistics/info/partyAgeStatistics", {
                    orgIds: this.wgID
                }).then(res => {
                    if (res.code == 200) {
                        if (res.content) {
                            let dangListX = [];
                            let dangListY = [];
                            res.content.forEach(item => {
                                // let obj={
                                //     name:item.name,value:item.total
                                // }
                                dangListX.push(item.name + '年')
                                dangListY.push(item.total)
                            });
                            this.dangLine(dangListX, dangListY);
                        }
                    } else {
                        this.$message.error(res.message);
                    }
                });
            },
            //其他党员活动
            getPartyActivits() {
                post("/admin/statistics/info/partyActivits", {
                    orgIds: this.wgID
                }).then(res => {
                    if (res.code == 200) {
                        if (res.content) {
                            this.hdList = res.content;
                        }
                    } else {
                        this.$message.error(res.message);
                    }
                });
            },
            getWorkPlan() {
                post("/admin/plant/info/findPlant",{
                    pageNo: 1,
                    pageSize: 10,
                    orgIds: this.wgID
                }).then(res => {
              if (res.code == 200) {
                  if(res.content){
                    this.workPlan = res.content.list[0];
                  }else {
                    this.workPlan = '';
                  }
                  
              } else {
                  this.$message.error(res.message);
              }
            });
            },
            //党员和志愿者统计
            getPartyVolunteer() {
                post("/admin/statistics/info/partyVolunteer", {
                    orgIds: this.wgID,
                    // orgId: this.wgID
                }).then(res => {
                    if (res.code == 200) {
                        if (res.content) {
                            res.content.forEach(item => {
                                if (item.name == "党员") {
                                    this.dangyuanNum = item.total;
                                }
                                if (item.name == "志愿者") {
                                    this.zyzNum = item.total;
                                }
                                // if (item.name == "党员+居委会成员（一肩挑）") {
                                //     this.jwhNum = item.total;
                                // }
                            })
                        }
                    } else {
                        this.$message.error(res.message);
                    }
                });
            },
            //三会一课统计
            getSessionLesson() {
                post("/admin/statistics/info/sessionLesson", {
                    orgIds: this.wgID
                }).then(res => {
                    if (res.code == 200) {
                        if (res.content) {
                            res.content.forEach(item => {
                                if (item.name == "支部委员大会") {
                                    this.Lesson.dhAll = item.totals;
                                    this.Lesson.dh = item.total;
                                }
                                if (item.name == "支部委员会") {
                                    this.Lesson.wyhAll = item.totals;
                                    this.Lesson.wyh = item.total;
                                }
                                if (item.name == "党小组会") {
                                    this.Lesson.dxzAll = item.totals;
                                    this.Lesson.dxz = item.total;
                                }
                                if (item.name == "党课") {
                                    this.Lesson.dkAll = item.totals;
                                    this.Lesson.dk = item.total;
                                }
                            })

                        }
                    } else {
                        this.$message.error(res.message);
                    }
                });
            },
            //三会一课统计
            getAssist() {
                post("/admin/statistics/info/assist", {
                    orgIds: this.wgID
                }).then(res => {
                    if (res.code == 200) {
                        if (res.content) {
                            this.assistList = res.content;
                        }
                    } else {
                        this.$message.error(res.message);
                    }
                });
            },
            clc() {
                this.off = true;
            },
            // cks(e) {
            //     if (e) {
            //         console.log(e);
            //         this.wgID=e;
            //         this.win = true;
            //         this.getEducation();
            //         this.getPartyAgeStatistics();
            //         this.getPartyActivits();
            //         this.getPartyVolunteer();
            //         this.getSessionLesson();
            //         this.getAssist();
            //         this.getDangWerShuJi();
            //         this.getWorkPlan();
            //     }
            // },
            cks(e) {
                if (e) {
                    console.log(e);
                    this.wgID=e;
                    this.getEducation();
                    this.getPartyAgeStatistics();
                    this.getPartyActivits();
                    this.getPartyVolunteer();
                    this.getSessionLesson();
                    this.getAssist();
                    // this.getDangWerShuJi();
                    this.getWorkPlan();
                    this.win = true;
                    post("/admin/statistics/info/findEvent", {
                        pageNo: 1,
                        pageSize: 7,
                        orgIds:e
                    }).then(res => {
                        if (res.code == 200) {
                            if (res.content) {
                                this.cksList=[];
                                res.content.list.forEach( item => {
                                    if(item.approvalStatus==5 || item.approvalStatus==6 || item.approvalStatus==14 ||item.approvalStatus==15){
                                        this.cksList.push(item)
                                    }
                                })
                                // this.cksList = res.content.list;
                                // this.complaintsList = res.content;
                            }
                        }
                    });
                }
            },
            getOrgName(name) {
                console.log('1200' + name)
                this.orgName1 = name;
            },
            // getDangWeiId(id) {
            //     console.log('1200' + id)
            //     // this.orgName1 = id;
            //     this.zhiBuId = id;
            // },
            ck(info) {
                //console.log(info);
                if (info == true) {
                    this.data = dataArr.dataArr[1];
                } else {
                    this.data = dataArr.dataArr[0];
                }
            },
            ckID(arr){
                console.log(arr);
            },
            //    画图
            handleOption(data) {
                const optionData = {};
                const legendArr = data.map(item => {
                    return item.name;
                });
                optionData.legend = {
                    right: 10,
                    top: 10,
                    data: legendArr,
                    orient: "vertical",
                    textStyle: {
                        color: "#fff"
                    }
                    // formatter: ["{a|{name}}", "{b|{name}}"].join("\n")
                };
                const seriesData = [
                    {
                        type: "pie",
                        radius: ["30%", "70%"],
                        avoidLabelOverlap: false,
                        label: {
                            show: true,
                            position: "inner",
                            formatter: "{d}%"
                        },
                        emphasis: {
                            label: {
                                show: true,
                                fontSize: "30",
                                fontWeight: "bold"
                            }
                        },
                        labelLine: {
                            show: false
                        },
                        data: data,
                        left: "-150px"
                    }
                ];
                optionData.series = seriesData;
                return optionData;
            },
            drawLine(index) {
                // 基于准备好的dom，初始化echarts实例
                let myChart = this.$echarts.init(document.getElementById("dangzuzhi"));
                // 绘制图表
                myChart.setOption(this.handleOption(this.dataArr[index]));
                myChart.setOption(this.handleOption(this.payArr));
            },
            xueliLine() {
                // 基于准备好的dom，初始化echarts实例
                let myChart = this.$echarts.init(document.getElementById("xueLiId"));
                // 绘制图表
                myChart.setOption(this.handleOption(this.xueliList));
            },
            // 党龄分布
            dangLine(dataX, dataY) {
                let myChart = this.$echarts.init(document.getElementById("danglFB"));
                let option_1 = {
                    tooltip: {
                        trigger: 'axis',
                        axisPointer: {            // 坐标轴指示器，坐标轴触发有效
                            type: 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
                        },
                    },
                    legend: {
                        data: ['男', '女'],
                        textStyle: {
                            color: "#fff"
                        }
                    },
                    grid: {
                        left: '3%',
                        right: '4%',
                        bottom: '3%',
                        containLabel: true
                    },
                    xAxis: [
                        {
                            type: 'category',
                            // name:'党龄',
                            data: dataX,
                            axisLabel: {
                                show: true,
                                textStyle: {
                                    color: '#ffffff'
                                }
                            },
                            axisLine: {
                                lineStyle: {
                                    type: 'solid',
                                    color: '#fff',//左边线的颜色
                                }

                            },
                        }
                    ],
                    yAxis: [
                        {
                            type: 'value',
                            splitLine: {show: false},
                            name:'人数',
                            axisLabel: {
                                show: true,
                                textStyle: {
                                    color: '#ffffff'
                                }
                            },
                            axisLine: {
                                lineStyle: {
                                    type: 'solid',
                                    color: '#fff',//左边线的颜色
                                }

                            },
                        }
                    ],
                    series: [
                        {
                            type: 'bar',
                            stack: '党龄',
                            barWidth: 30,
                            data: dataY,
                            color: "#08a6fb"
                        },
                        // {
                        //     name: '女',
                        //     type: 'bar',
                        //     stack: '党龄',
                        //     barWidth : 30,
                        //     data: [220, 182, 191, 234, 290],
                        //     color:"#5bd0ac"
                        // }
                    ]
                };
                myChart.setOption(option_1);
                // myChart.setOption(this.handleOption(this.dataArr[4]));

            },
            MapInfor() {
                var planePath =
                    "path://M1705.06,1318.313v-89.254l-319.9-221.799l0.073-208.063c0.521-84.662-26.629-121.796-63.961-121.491c-37.332-0.305-64.482,36.829-63.961,121.491l0.073,208.063l-319.9,221.799v89.254l330.343-157.288l12.238,241.308l-134.449,92.931l0.531,42.034l175.125-42.917l175.125,42.917l0.531-42.034l-134.449-92.931l12.238-241.308L1705.06,1318.313z";
                var myChart = this.$echarts.init(document.getElementById("main"));
                myChart.setOption({
                    title: {
                        left: "center",
                        textStyle: {
                            color: "#fff"
                        }
                    },
                    amap: {
                        zoom: 16,
                        zooms: [3, 20],
                        mapStyle: "amap://styles/darkblue", //地图主题
                        center: [116.841994, 32.634171] //中心点
                    },
                    animation: false,
                    series: []
                });
                let arr2 = [
                    //   [116.841022,32.629936],[116.843329,32.631137],[116.841365,32.632547],[116.842508,32.633238],
                    // [116.84431,32.633301],[116.843935,32.634431],[116.844697,32.63551],
                    // [116.843398,32.635307],[116.842368,32.635041],[116.841467,32.635176],
                    // [116.840416,32.63477]
                ];
                let arr3 = [
                    [116.841022, 32.629936], [116.843329, 32.631137], [116.841365, 32.632547], [116.842508, 32.633238],
                    [116.84431, 32.633301], [116.843935, 32.634431], [116.844697, 32.63551],
                    [116.843398, 32.635307], [116.842368, 32.635041], [116.841467, 32.635176],
                    [116.840416, 32.63477]
                ];
                //添加点标记
                var cluster,
                    markers = [];
                var points = [];
                arr3.forEach(ele => {
                    points.push({lnglat: ele})
                })
                //创建所有的点标记
                for (var i = 0; i < points.length; i += 1) {
                    let m = new AMap.Marker({
                        position: points[i]["lnglat"],
                        content:
                            '<div style=" height: 18px; width: 18px; border-radius: 12px; box-shadow: hsl(180, 100%, 50%) 0px 0px 1px;"><img src="http://58.243.183.70:8082/dataEye-yanpanpingtai-HF/src/img/party/dian_icon.png" alt=""></div>',
                        offset: new AMap.Pixel(-10, -10)
                    });
                    markers.push(m);
                    _this = this;
                    //给点标记添加click事件
                    m.on("click", function (e) {
                        console.log(e);
                        _this.$emit("cks", true);
                    });
                }

                // map.plugin(["AMap.MarkerClusterer"], function() {
                //   cluster = new AMap.MarkerClusterer(map, markers, { gridSize: 30 });
                //   map.setFitView();
                // });
                //上面的部分是echarts的配置，需要注意的是amap，这里的配置就是针对 高德地图 的配置了，而支持哪些配置
                //可以去高德地图的开发平台去查看

                var map = myChart
                    .getModel()
                    .getComponent("amap")
                    .getAMap();
                var layer = myChart
                    .getModel()
                    .getComponent("amap")
                    .getLayer();
                //1
                map.add(markers);
                var polygonArr = [
                    [116.840303, 32.63369],
                    [116.840416, 32.633279],
                    [116.841633, 32.6335],
                    [116.842347, 32.631553],
                    [116.843683, 32.632217],
                    [116.842878, 32.63449],
                    [116.840646, 32.633902]
                ];
                var polygon = new AMap.Polygon({
                    map: map,
                    path: polygonArr, //设置多边形边界路径
                    strokeColor: "#80f", //线颜色
                    strokeOpacity: 0.2, //线透明度
                    strokeWeight: 3, //线宽
                    fillColor: "#80f", //填充色
                    fillOpacity: 0.2, //填充透明度
                    extData: {
                        name: "治东社区",
                        address: "安徽省淮南市治东社区第五网格",
                        tel: "0556-1231231"
                    }
                });
                //2
                var polygonArr = [
                    [116.840426, 32.633261],
                    [116.841623, 32.633487],
                    [116.842336, 32.631535],
                    [116.84144, 32.631097],
                    [116.841167, 32.63182],
                    [116.84077, 32.632213]
                ];
                var polygon = new AMap.Polygon({
                    map: map,
                    path: polygonArr, //设置多边形边界路径
                    strokeColor: "#800", //线颜色
                    strokeOpacity: 0.2, //线透明度
                    strokeWeight: 3, //线宽
                    fillColor: "#800", //填充色
                    fillOpacity: 0.2, //填充透明度
                    extData: {
                        name: "治东社区",
                        address: "安徽省淮南市治东社区第六网格",
                        tel: "0556-1231231"
                    }
                });
                //3
                var polygonArr = [
                    [116.84011, 32.630564],
                    [116.840249, 32.628693],
                    [116.843178, 32.630112],
                    [116.8421, 32.630153],
                    [116.84202, 32.630758],
                    [116.841703, 32.630722],
                    [116.841601, 32.63116],
                    [116.840764, 32.630762]
                ];
                var polygon = new AMap.Polygon({
                    map: map,
                    path: polygonArr, //设置多边形边界路径
                    strokeColor: "#f00", //线颜色
                    strokeOpacity: 0.2, //线透明度
                    strokeWeight: 3, //线宽
                    fillColor: "#f00", //填充色
                    fillOpacity: 0.2, //填充透明度
                    extData: {
                        name: "治东社区",
                        address: "安徽省淮南市治东社区第一网格",
                        tel: "0556-1231231"
                    }
                });
                //4
                var polygonArr = [
                    [116.841623, 32.631169],
                    [116.841719, 32.630726],
                    [116.842025, 32.630758],
                    [116.8421, 32.630144],
                    [116.843216, 32.630121],
                    [116.845748, 32.631363],
                    [116.845641, 32.631598],
                    [116.845442, 32.631467],
                    [116.844525, 32.63261]
                ];
                var polygon = new AMap.Polygon({
                    map: map,
                    path: polygonArr, //设置多边形边界路径
                    strokeColor: "#0fc", //线颜色
                    strokeOpacity: 0.2, //线透明度
                    strokeWeight: 3, //线宽
                    fillColor: "#0fc", //填充色
                    fillOpacity: 0.2, //填充透明度
                    extData: {
                        name: "治东社区",
                        address: "安徽省淮南市治东社区第九网格",
                        tel: "0556-1231231"
                    }
                });
                var polygonArr = [
                    [116.843248, 32.633518],
                    [116.844015, 32.633685],
                    [116.843913, 32.634056],
                    [116.844477, 32.634164],
                    [116.845496, 32.633929],
                    [116.845442, 32.633035],
                    [116.843699, 32.632217]
                ];
                var polygon = new AMap.Polygon({
                    map: map,
                    path: polygonArr, //设置多边形边界路径
                    strokeColor: "#082", //线颜色
                    strokeOpacity: 0.2, //线透明度
                    strokeWeight: 3, //线宽
                    fillColor: "#082", //填充色
                    fillOpacity: 0.2, //填充透明度
                    extData: {
                        name: "治东社区",
                        address: "安徽省淮南市治东社区第八网格",
                        tel: "0556-1231231"
                    }
                });
                var polygonArr = [
                    [116.842899, 32.634499],
                    [116.843999, 32.634688],
                    [116.845372, 32.635054],
                    [116.845592, 32.634621],
                    [116.845512, 32.633929],
                    [116.844503, 32.634169],
                    [116.843913, 32.634065],
                    [116.844021, 32.633672],
                    [116.843248, 32.633509]

                ];
                var polygon = new AMap.Polygon({
                    map: map,
                    path: polygonArr, //设置多边形边界路径
                    strokeColor: "#0ff", //线颜色
                    strokeOpacity: 0.2, //线透明度
                    strokeWeight: 3, //线宽
                    fillColor: "#0ff", //填充色
                    fillOpacity: 0.2, //填充透明度
                    extData: {
                        name: "治东社区",
                        address: "安徽省淮南市治东社区第七网格",
                        tel: "0556-1231231"
                    }
                });
                var polygonArr = [
                    [116.845362, 32.635068],
                    [116.845244, 32.635542],
                    [116.844992, 32.635917],
                    [116.844734, 32.636265],
                    [116.843769, 32.635922],
                    [116.843972, 32.635578],
                    [116.844187, 32.635393],
                    [116.844278, 32.635149],
                    [116.844171, 32.635009],
                    [116.844251, 32.634765]
                ];
                var polygon = new AMap.Polygon({
                    map: map,
                    path: polygonArr, //设置多边形边界路径
                    strokeColor: "#008", //线颜色
                    strokeOpacity: 0.2, //线透明度
                    strokeWeight: 3, //线宽
                    fillColor: "#008", //填充色
                    fillOpacity: 0.2, //填充透明度
                    extData: {
                        name: "治东社区",
                        address: "安徽省淮南市治东社区第四网格",
                        tel: "0556-1231231"
                    }
                });
                var polygonArr = [
                    [116.843597, 32.636287],
                    [116.842422, 32.635913],
                    [116.842878, 32.63449],
                    [116.844251, 32.634761],
                    [116.844166, 32.635005],
                    [116.844273, 32.635154],
                    [116.844187, 32.635379],
                    [116.843983, 32.63556],
                    [116.843844, 32.635777]
                ];
                var polygon = new AMap.Polygon({
                    map: map,
                    path: polygonArr, //设置多边形边界路径
                    strokeColor: "#0f0", //线颜色
                    strokeOpacity: 0.2, //线透明度
                    strokeWeight: 3, //线宽
                    fillColor: "#0f0", //填充色
                    fillOpacity: 0.2, //填充透明度
                    extData: {
                        name: "治东社区",
                        address: "安徽省淮南市治东社区第三网格",
                        tel: "0556-1231231"
                    }
                });
                var polygonArr = [
                    [116.842422, 32.635885],
                    [116.841773, 32.635745],
                    [116.842224, 32.634322],
                    [116.842867, 32.63449]
                ];
                var polygon = new AMap.Polygon({
                    map: map,
                    path: polygonArr, //设置多边形边界路径
                    strokeColor: "#f00", //线颜色
                    strokeOpacity: 0.2, //线透明度
                    strokeWeight: 3, //线宽
                    fillColor: "#f00", //填充色
                    fillOpacity: 0.2, //填充透明度
                    extData: {
                        name: "治东社区",
                        address: "安徽省淮南市治东社区第一网格",
                        tel: "0556-1231231"
                    }
                });
                var polygonArr = [
                    [116.841768, 32.635759],
                    [116.841966, 32.6358],
                    [116.841827, 32.635917],
                    [116.841703, 32.635962],
                    [116.84151, 32.635971],
                    [116.841371, 32.63594],
                    [116.841178, 32.635885],
                    [116.840963, 32.63575],
                    [116.840684, 32.635538],
                    [116.840807, 32.635542],
                    [116.841017, 32.635556],
                    [116.84107, 32.635126],
                    [116.841086, 32.634883],
                    [116.841124, 32.634729],
                    [116.841156, 32.63472],
                    [116.841269, 32.634562],
                    [116.841258, 32.634413],
                    [116.840941, 32.634277],
                    [116.840577, 32.634151],
                    [116.840228, 32.633984],
                    [116.840308, 32.63369],
                    [116.84063, 32.633902],
                    [116.842213, 32.634322]
                ];
                var polygon = new AMap.Polygon({
                    map: map,
                    path: polygonArr, //设置多边形边界路径
                    strokeColor: "#ff0", //线颜色
                    strokeOpacity: 0.2, //线透明度
                    strokeWeight: 3, //线宽
                    fillColor: "#ff0", //填充色
                    fillOpacity: 0.2, //填充透明度
                    extData: {
                        name: "治东社区",
                        address: "安徽省淮南市治东社区第二网格",
                        tel: "0556-1231231"
                    }
                });
                var polygonArr = [
                    [116.840689, 32.635524],
                    [116.840604, 32.635529],
                    [116.839981, 32.635136],
                    [116.839767, 32.635068],
                    [116.839885, 32.633595],
                    [116.840303, 32.633681],
                    [116.840223, 32.633961],
                    [116.840561, 32.634146],
                    [116.841258, 32.634408],
                    [116.841263, 32.634553],
                    [116.841172, 32.634702],
                    [116.841124, 32.634711],
                    [116.841017, 32.63556]
                ];
                var polygon = new AMap.Polygon({
                    map: map,
                    path: polygonArr, //设置多边形边界路径
                    strokeColor: "#0f0", //线颜色
                    strokeOpacity: 0.2, //线透明度
                    strokeWeight: 3, //线宽
                    fillColor: "#0f0", //填充色
                    fillOpacity: 0.2, //填充透明度
                    extData: {
                        name: "治东社区",
                        address: "安徽省淮南市治东社区第三网格",
                        tel: "0556-1231231"
                    }
                });
                var _this = this;
                polygon.on("click", function (e) {
                    let data = this.getExtData();
                    this.ck = !this.ck;
                    _this.$emit("ck", this.ck);
                    //   var info = [];
                    //   info.push(
                    //     '<div style="padding:0px 0px 0px 4px;"><b>' + data.name + "</b>"
                    //   );
                    //   info.push("电话 : " + data.tel);
                    //   info.push("地址 :" + data.address + "</div></div>");
                    //   infoWindow = new AMap.InfoWindow({
                    //     content: info.join("<br/>") //使用默认信息窗体框样式，显示信息内容
                    //   });
                    //   infoWindow.open(map, e.lnglat);
                });
                var series = [];

                arr2.forEach(ele => {
                    series.push({
                            name: "2",
                            coordinateSystem: "amap",
                            type: "lines",
                            zlevel: 1,
                            effect: {
                                show: true,
                                period: 6,
                                trailLength: 0.7,
                                color: "#fff",
                                symbolSize: 3
                            },
                            lineStyle: {
                                normal: {
                                    color: "#a6c84c",
                                    width: 0,
                                    curveness: 0.2
                                }
                            },
                            data: [
                                {
                                    fromName: "上海",
                                    toName: "包头",
                                    coords: [
                                        ele,
                                        [116.841994, 32.634171]
                                    ],
                                    value: 95
                                }
                            ]
                        },
                        {
                            name: "上海 Top10",
                            coordinateSystem: "amap",
                            type: "lines",
                            zlevel: 2,
                            effect: {
                                show: true,
                                period: 6,
                                trailLength: 0,
                                symbol: planePath,
                                symbolSize: 15
                            },
                            symbol: ["none", "arrow"],
                            symbolSize: 10,
                            lineStyle: {
                                normal: {
                                    color: "#a6c84c",
                                    width: 1,
                                    opacity: 0.6,
                                    curveness: 0.2
                                }
                            },
                            data: [
                                {
                                    fromName: "上海",
                                    toName: "包头",
                                    coords: [
                                        ele,
                                        [116.841994, 32.634171]
                                    ],
                                    value: 95
                                }
                            ]
                        },
                        {
                            name: "上海 Top10",
                            type: "effectScatter",
                            coordinateSystem: "amap",
                            zlevel: 2,
                            rippleEffect: {
                                brushType: "stroke"
                            },
                            label: {
                                normal: {
                                    show: true,
                                    position: "bottom",
                                    formatter: "{b}"
                                }
                            },
                            itemStyle: {
                                normal: {
                                    color: "#a6c84c"
                                }
                            },
                            data: [
                                {
                                    name: "社区服务中心",
                                    value: [116.841994, 32.634171]
                                }
                            ]
                        },)
                })

                myChart.setOption({
                    series: series
                });

                //下面是确保高德地图渲染的时候，echarts同时也需要再次渲染一次，保持位置的同步
                layer.render = function () {
                    // let series = myChart.getOption().seriesIndexes;
                    // myChart.setOption({
                    //     series: []
                    // });
                    myChart.setOption({
                        series: series
                    });
                };
            }
        }
    };
</script>
<style lang="less" scoped>
    * {
        box-sizing: border-box;
    }

    p, div {
        color: #fff;
    }

    .res-title {
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 169px;
        background: url(../../../assets/images/bigData/bgColor.png) no-repeat;
        -webkit-background-size: 100% 100%;
        background-size: 100% 100%;
        z-index: 3;
    }

    .res-title img {
        display: block;
        width: 1918px;
        height: 169px;
        margin: 0 auto;
    }

    .res-title h4 {
        position: absolute;
        top: 0;
        left: 0;
        text-align: center;
        width: 100%;
        height: 100%;
        line-height: 89px;
        color: #fff;
        font-size: 34px;
        font-weight: Bold;
        letter-spacing: 8px !important;
    }

    .full-content .main {
        /*width: 1920px;*/
        /*height: 1080px;*/
        margin: 0 auto;
        position: relative;
    }

    .full-content .main .left-main-position {
        position: absolute;
        left: 12px;
        top: 90px;
        width: 404px;
        height: 726px;
        background: rgba(2, 29, 51, 0.7);
        border: 1px solid #324cb0;
        box-shadow: 0px 0px 18px 2px rgba(21, 213, 241, 0.19);
        z-index: 3;
    }

    .full-content .main .left-main-position .left-main {
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
    }

    .top-left, .top-right, .bottom-left, .bottom-right {
        position: absolute;
        width: 22px;
        height: 22px;
    }

    .top-left {
        top: 0;
        left: 0;
        background: url(../../../assets/images/bigData/zuo1_img.png) no-repeat;
    }

    .top-right {
        top: 0;
        right: 0;
        background: url(../../../assets/images/bigData/you1_img.png) no-repeat;
    }

    .bottom-left {
        bottom: 0;
        left: 0;
        background: url(../../../assets/images/bigData/zuo2_img.png) no-repeat;
    }

    .bottom-right {
        bottom: 0;
        right: 0;
        background: url(../../../assets/images/bigData/you2_img.png) no-repeat;
    }

    .full-content .main .left-main-position .left-main .Pyramid {
        padding: 0 23px;
        box-sizing: border-box;
    }

    .full-content .main .left-main-position .left-main .Pyramid .Pyramid-title::after {
        content: '';
        display: block;
        width: 4px;
        height: 13px;
        position: relative;
        top: -18px;
        left: -10px;
        background-color: #fff;
    }

    .full-content .main .left-main-position .left-main .Pyramid .mid-Pyramid {
        height: 40px;
        background: rgba(23, 67, 180, 0.6);
        border-radius: 2px;
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0 24px;
        box-sizing: border-box;
    }

    .full-content .main .left-main-position .left-main .Pyramid .mid-Pyramid .left-mid-title {
        font-size: 16px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #c4faff;
        line-height: 18px;
    }

    .full-content .main .left-main-position .left-main .Pyramid .mid-Pyramid .left-mid-num {
        font-size: 16px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: rgba(230, 48, 123, 0.9);
        line-height: 13px;
    }

    .full-content .main .left-main-position .left-main .Pyramid .mid-Pyramid .left-mid-num span {
        font-size: 28px;
        font-family: UniDreamLED;
        font-weight: 400;
        color: #e6307b;
        line-height: 13px;
        opacity: 0.9;
        font-family: 'Unidtrsmled';
    }

    .full-content .main .left-main-position .left-main .Pyramid .footer-Pyramid {
        height: 196px;
        background: url(../../../assets/images/bigData/shanfeng.png) no-repeat;
        background-position: center;
        position: relative;
        font-size: 11px;
    }

    .full-content .main .left-main-position .left-main .Pyramid .footer-Pyramid .title1 {
        position: absolute;
        top: 37px;
        left: 83px;
    }

    .full-content .main .left-main-position .left-main .Pyramid .footer-Pyramid span {
        color: #F6BD16;
        font-family: 'Unidtrsmled';
        margin-left: 2px;
    }

    .full-content .main .left-main-position .left-main .Pyramid .footer-Pyramid .title2 {
        position: absolute;
        top: 50px;
        left: 227px;
    }

    .full-content .main .left-main-position .left-main .Pyramid .footer-Pyramid .title3 {
        position: absolute;
        top: 71px;
        left: 47px;
    }

    .full-content .main .left-main-position .left-main .Pyramid .footer-Pyramid .title4 {
        position: absolute;
        top: 88px;
        left: 250px;
    }

    .full-content .main .left-main-position .left-main .Pyramid .footer-Pyramid .title5 {
        position: absolute;
        top: 107px;
        left: 6px;
    }

    .full-content .main .left-main-position .left-main .Party-organization-construction {
        padding: 0 23px;
        box-sizing: border-box;
    }

    .full-content .main .left-main-position .left-main .Party-organization-construction .Party-organization-title {
        text-align: left;
        height: auto;
    }

    .full-content .main .left-main-position .left-main .Party-organization-construction .Party-organization-title::after {
        content: '';
        display: block;
        width: 4px;
        height: 13px;
        position: relative;
        top: -18px;
        left: -10px;
        background-color: #fff;
    }

    .full-content .main .left-main-position .left-main .Party-organization-construction .Party-organization-content {
        display: flex;
        height: 76px;
        width: 100%;
    }

    .full-content .main .left-main-position .left-main .Party-organization-construction .Party-organization-content .right-tab {
        padding-top: 20px;
    }

    table {
        table-layout: fixed;
    }

    .full-content .main .left-main-position .left-main .Party-organization-construction .Party-organization-content .right-tab table thead {
        color: #BCD6FF;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #bcd6ff;
        line-height: 26px;
    }

    .full-content .main .left-main-position .left-main .Party-organization-construction .Party-organization-content .right-tab table tbody {
        font-size: 12px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #ffffff;
        line-height: 26px;
    }

    table tr td {
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        -o-text-overflow: ellipsis;
        -moz-text-overflow: ellipsis;
        -webkit-text-overflow: ellipsis;
    }

    .full-content .main .left-main-position .left-main .Party-organization-construction .Party-organization-content .right-tab .round-dian {
        width: 10px;
        height: 10px;
        border-radius: 50%;
    }

    .full-content .main .left-main-position .left-main .party-serve {
        padding: 0 23px;
        box-sizing: border-box;
    }

    .full-content .main .left-main-position .left-main .party-serve .party-serve-title {
        text-align: left;
        height: auto;
    }

    .full-content .main .left-main-position .left-main .party-serve .party-serve-title::after {
        content: '';
        display: block;
        width: 4px;
        height: 13px;
        position: relative;
        top: -18px;
        left: -10px;
        background-color: #fff;
    }

    .full-content .main .left-main-position .left-main .party-serve .serve-party-tab .tab-h {
        height: 32px;
        align-items: center;
    }

    .full-content .main .left-main-position .left-main .party-serve .serve-party-tab .header {
        background-color: #3352A1;
        display: flex;
    }

    .full-content .main .left-main-position .left-main .party-serve .serve-party-tab .header .header-left-title {
        width: 170px;
        text-align: center;
        color: #ffffff;
    }

    .full-content .main .left-main-position .left-main .party-serve .serve-party-tab .header .header-right-title {
        flex-grow: 1;
        text-align: center;
        color: #ffffff;
    }

    .full-content .main .left-main-position .left-main .party-serve .serve-party-tab .header-body-content {
        width: 100%;
    }

    .full-content .main .left-main-position .left-main .party-serve .serve-party-tab .header-body-content .heabody {
        display: flex;
        align-items: center;
    }

    .full-content .main .left-main-position .left-main .party-serve .serve-party-tab .header-body-content .heabody .headerbody-left {
        width: 170px;
        text-align: center;
        color: #ffffff;
    }

    .full-content .main .left-main-position .left-main .party-serve .serve-party-tab .header-body-content .heabody .headerbody-right {
        flex-grow: 1;
        text-align: center;
        color: #ffffff;
    }

    .full-content .main .left-right-small-btn {
        position: absolute;
        left: 428px;
        top: 90px;
        width: 104px;
        z-index: 50;
    }

    .full-content .main .left-right-small-btn li {
        width: 104px;
        height: 80px;
        background: url(../../../assets/images/bigData/shuju_bg.png) no-repeat;
        margin-bottom: 10px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }

    .full-content .main .left-right-small-btn li span {
        font-size: 32px;
        font-family: 'Unidtrsmled';
        font-weight: 400;
        color: #e6307b;
    }

    .full-content .main .left-right-small-btn li p {
        margin: 5px 0;
        font-size: 12px;
        font-weight: 400;
        color: #ffffff;
        padding-bottom: 5px;
    }

    .full-content .main .right-main-position {
        position: absolute;
        right: 12px;
        top: 90px;
        width: 404px;
        height: 726px;
        background: rgba(2, 29, 51, 0.7);
        border: 1px solid #324cb0;
        box-shadow: 0px 0px 18px 2px rgba(21, 213, 241, 0.19);
        z-index: 3;
    }

    .full-content .main .right-main-position .right-main {
        width: 100%;
        height: 100%;
        position: relative;
    }

    .full-content .main .right-main-position .right-main .right-top {
        padding: 0 0px;
        padding-top: 25px;
        box-sizing: border-box;
    }

    .full-content .main .right-main-position .right-main .right-top .right-top-title {
        text-align: left;
        height: auto;
        margin-left: 23px;
    }

    .full-content .main .right-main-position .right-main .right-top .right-top-title::after {
        content: '';
        display: block;
        width: 4px;
        height: 13px;
        position: relative;
        top: -18px;
        left: -10px;
        background-color: #fff;
    }

    .full-content .main .right-main-position .right-main .right-top .activity-content {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        padding-left: 20px;
    }

    .full-content .main .right-main-position .right-main .right-top .activity-content .activity-item {
        display: flex;
        width: 48%;
        margin-bottom: 25px;
        margin-top: 3px;
        margin-right: 0px;
    }

    .full-content .main .right-main-position .right-main .right-top .activity-content .activity-item .activity-right .activity-right-top {
        font-size: 12px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #ffffff;
        line-height: 31px;
    }

    .full-content .main .right-main-position .right-main .right-top .activity-content .activity-item .activity-right .activity-right-top span {
        font-size: 30px;
        font-weight: 400;
        color: #ffffff;
        font-family: 'Unidtrsmled';
    }

    .full-content .main .right-main-position .right-main .right-top .activity-content .activity-item .activity-right .activity-right-bot {
        font-size: 12px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #cccccc;
    }

    .full-content .main .right-main-position .right-main .right-mid {
        padding: 0 23px;
        box-sizing: border-box;
    }

    .full-content .main .right-main-position .right-main .right-mid .right-mid-title {
        text-align: left;
    }

    .shuxian {
        position: relative;
    }

    .shuxian::after {
        content: '';
        display: block;
        width: 4px;
        height: 13px;
        position: relative;
        top: -18px;
        left: -10px;
        background-color: #fff;
    }

    .full-content .main .right-main-position .right-main .right-mid .right-mid-ear {
        display: flex;
    }

    .full-content .main .right-main-position .right-main .right-mid .right-mid-ear .ear-nav {
        display: flex;
    }

    .full-content .main .right-main-position .right-main .right-mid .right-mid-ear .ear-nav .earnav-ac {
        background: url(../../../assets/images/bigData/dianji.png);
    }

    .full-content .main .right-main-position .right-main .right-mid .right-mid-ear .ear-nav .earnav-item {
        width: 70px;
        height: 27px;
        cursor: pointer;
        background-size: 100%;
        display: flex;
        align-items: center;
        font-size: 12px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #ffffff;
        line-height: 45px;
        opacity: 0.8;
        justify-content: center;
    }

    .full-content .main .right-main-position .right-main .right-mid .ear-wrap {
        height: 187px;
        width: 100%;
        display: flex;
    }

    .full-content .main .right-main-position .right-main .right-mid .ear-wrap .right-list-canear {
        display: flex;
        flex-wrap: wrap;
        padding: 25px 0;
        justify-content: space-between;
    }

    .full-content .main .right-main-position .right-main .right-mid .ear-wrap .right-list-canear .right-list-canear-item {
        display: flex;
        width: 65px;
        height: 30px;
        font-size: 12px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        align-items: center;
        margin: 0;
        margin-right: 20px;
        color: #ffffff;
    }

    .full-content .main .right-main-position .right-main .right-mid .ear-wrap .right-list-canear .right-list-canear-item .item-dian {
        width: 10px;
        height: 6px;
        border-radius: 3px;
        margin-right: 4px;
    }

    .full-content .main .right-main-position .right-main .right-bot {
        padding: 0 23px;
        box-sizing: border-box;
    }

    .full-content .main .right-main-position .right-main .right-bot .bot-title-positive {
        text-align: left;
    }

    .full-content .main .right-main-position .right-main .right-bot #tab-positive {
        border-collapse: collapse;
    }

    .full-content .main .right-main-position .right-main .right-bot #tab-positive thead {
        background: #3352A1;
    }

    /*地图*/
    .mid-top {
        width: 100%;
        height: 100vh;
    }

    /*弹窗*/
    .Max-alter {
        width: 1620px;
        height: 1008px;
        position: absolute;
        top: 0;
        left: 6%;
        z-index: 1111;
        transform: translate(-50%, -50%);
        background: rgba(33, 34, 47, 0.7);
        border: 1px solid #324cb0;
        box-shadow: 0px 0px 18px 2px rgba(21, 213, 241, 0.19);
        display: flex;
        align-items: center;
        justify-content: center;
        transition: all 0.3s;
        -webkit-transition: all 0.3s;
        transform: scale(0.85);
    }

    .Max-alter .bgw {
        width: 22px;
        height: 22px;
    }

    .Max-alter .left-top-bg {
        background: url(../../../assets/images/bigData/zuo1_img.png);
        position: absolute;
        top: 0;
        left: 0;
    }

    .Max-alter .right-top-bg {
        background: url(../../../assets/images/bigData/you1_img.png);
        position: absolute;
        top: 0;
        right: 0;
    }

    .Max-alter .left-bot-bg {
        background: url(../../../assets/images/bigData/zuo2_img.png);
        position: absolute;
        bottom: 0;
        left: 0;
    }

    .Max-alter .right-bot-bg {
        background: url(../../../assets/images/bigData/you2_img.png);
        position: absolute;
        bottom: 0;
        right: 0;
    }

    .Max-alter .party-branch {
        width: 1560px;
        height: 948px;
        background: rgba(6, 31, 86, 0.8);
        display: flex;
        flex-direction: column;
    }

    .Max-alter .party-branch .party-header1 {
        width: 1563px;
        height: 52px;
        background-color: rgba(47, 98, 209, 0.26);
    }

    .Max-alter .party-branch .party-header1 .party-header1-title {
        background: url(../../../assets/images/bigData/biaoti.png) no-repeat;
        height: 100%;
        background-position: center;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 26px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #ffffff;
    }

    .Max-alter .party-branch .party-content-wrap {
        flex-grow: 1;
        display: flex;
        padding: 30px;
        box-sizing: border-box;
        flex-direction: column;
    }

    .Max-alter .party-branch .party-content-wrap .top-content-wrap {
        display: flex;
        justify-content: space-between;
        width: 100%;
        margin-bottom: 14px;
    }

    .Max-alter .party-branch .party-content-wrap .top-content-wrap .organizational-structure {
        width: 548px;
        height: 296px;
        background: rgba(9, 42, 102, 0.6);
        padding: 15px 21px;
        display: flex;
        flex-direction: column;
    }

    .Max-alter .party-branch .party-content-wrap .top-content-wrap .organizational-structure .header1 {
        display: flex;
        justify-content: flex-start;
        align-items: center;
    }

    .Max-alter .party-branch .party-content-wrap .top-content-wrap .organizational-structure .header1 img {
        width: 30px;
        height: 26px;
        margin-right: 14px;
    }

    .Max-alter .party-branch .party-content-wrap .top-content-wrap .organizational-structure .header1 .header1-title {
        font-size: 24px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #aaceff;
    }

    .Max-alter .party-branch .party-content-wrap .top-content-wrap .organizational-structure .content-wrap {
        flex-grow: 1;
        display: flex;
        align-items: center;
    }

    .Max-alter .party-branch .party-content-wrap .top-content-wrap .organizational-structure .content-wrap .content-box {
        display: flex;
        align-items: center;
    }

    .Max-alter .party-branch .party-content-wrap .top-content-wrap .organizational-structure .content-wrap .content-box .left-peo {
        height: 98px;
        display: flex;
        margin-right: 32px;
    }

    .Max-alter .party-branch .party-content-wrap .top-content-wrap .organizational-structure .content-wrap .content-box .left-peo img {
        width: 68px;
        height: 98px;
        margin-right: 13px;
    }

    .Max-alter .party-branch .party-content-wrap .top-content-wrap .organizational-structure .content-wrap .content-box .left-peo .peo-information {
        display: flex;
        align-items: center;
        flex-direction: column;
        justify-content: space-around;
    }

    .Max-alter .party-branch .party-content-wrap .top-content-wrap .organizational-structure .content-wrap .content-box .left-peo .peo-information .zhiwei {
        font-size: 18px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #f7c25e;
        width:90px;
        text-align: center;
    }

    .Max-alter .party-branch .party-content-wrap .top-content-wrap .organizational-structure .content-wrap .content-box .left-peo .peo-information .name-peo {
        font-size: 16px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #ffffff;
    }

    .Max-alter .party-branch .party-content-wrap .top-content-wrap .organizational-structure .content-wrap .content-box .left-peo .peo-information .tel-peo {
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #ffffff;
    }

    .Max-alter .party-branch .party-content-wrap .top-content-wrap .organizational-structure .content-wrap .content-box .right-content-list {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        margin-right: 20px;
    }

    .Max-alter .party-branch .party-content-wrap .top-content-wrap .organizational-structure .content-wrap .content-box .right-content-list .item-c-r {
        display: flex;
        margin-bottom: 19px;
    }

    .Max-alter .party-branch .party-content-wrap .top-content-wrap .organizational-structure .content-wrap .content-box .right-content-list .item-c-r .l-info {
        margin-left: 16px;
    }

    .Max-alter .party-branch .party-content-wrap .top-content-wrap .organizational-structure .content-wrap .content-box .right-content-list .item-c-r .l-info .info-num {
        text-align: left;
        font-size: 12px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #ffffff;
    }

    .Max-alter .party-branch .party-content-wrap .top-content-wrap .organizational-structure .content-wrap .content-box .right-content-list .item-c-r .l-info .info-num span {
        font-family: 'Unidtrsmled';
        font-size: 24px;
    }

    .Max-alter .party-branch .party-content-wrap .top-content-wrap .organizational-structure .content-wrap .content-box .right-content-list .item-c-r .l-info .info-text {
        font-size: 12px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #cccccc;
    }

    .Max-alter .party-branch .party-content-wrap .top-content-wrap .mid-org-str {
        display: flex;
        flex-direction: column;
        width: 430px;
        height: 296px;
        position: relative;
    }

    .Max-alter .party-branch .party-content-wrap .top-content-wrap .mid-org-str .header1 {
        width: 100%;
        height: 47px;
        background: rgba(9, 42, 102, 0.6);
        position: absolute;
        top: 0;
        left: 0;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        padding-left: 21px;
        padding-top: 15px;
        z-index: 8;
    }

    .Max-alter .party-branch .party-content-wrap .top-content-wrap .mid-org-str .header1 img {
        width: 30px;
        height: 26px;
        margin-right: 14px;
    }

    .Max-alter .party-branch .party-content-wrap .top-content-wrap .mid-org-str .header1 .header1-title {
        font-size: 24px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #aaceff;
    }

    .Max-alter .party-branch .party-content-wrap .top-content-wrap .mid-org-str .content-wrap {
        position: absolute;
        top: 47px;
        left: 0;
        height: 558px;
        width: 100%;
        overflow: auto;
        background: rgba(9, 42, 102, 0.6);
        padding-right: 15px;
        padding-bottom: 15px;
    }

    .Max-alter .party-branch .party-content-wrap .top-content-wrap .mid-org-str .content-wrap .p11 {
        text-align: left;
        font-size: 18px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #8fbff2;
        padding-top: 29px;
        padding-left: 21px;
    }

    .Max-alter .clear-alter-box {
        cursor: pointer;
        width: 15px;
        height: 15px;
        position: absolute;
        top: 13px;
        right: 13px;
    }

    .Max-alter .party-branch .party-content-wrap .top-content-wrap .right-org-str {
        background: rgba(9, 42, 102, 0.6);
        padding: 15px 21px;
        display: flex;
        flex-direction: column;
        width: 485px;
        height: 296px;
    }

    .Max-alter .party-branch .party-content-wrap .top-content-wrap .right-org-str .content-wrap {
        height: 190px;
        width: 443px;
    }

    .Max-alter .party-branch .party-content-wrap .top-content-wrap .right-org-str .f-wrap {
        width: 100%;
        display: flex;
        justify-content: center;
    }

    .Max-alter .party-branch .party-content-wrap .top-content-wrap .right-org-str .f-wrap .text-xueli-rank {
        display: flex;
        width: 230px;
        flex-wrap: wrap;
    }

    .Max-alter .party-branch .party-content-wrap .top-content-wrap .right-org-str .f-wrap .text-xueli-rank .rank-item {
        display: flex;
        align-items: center;
        margin-right: 23px;
        margin-bottom: 13px;
    }

    .Max-alter .party-branch .party-content-wrap .top-content-wrap .right-org-str .f-wrap .text-xueli-rank .rank-item .text-color {
        width: 10px;
        height: 7px;
        border-radius: 4px;
    }

    .Max-alter .party-branch .party-content-wrap .top-content-wrap .right-org-str .f-wrap .text-xueli-rank .rank-item .text-rank-name {
        margin-left: 3px;
        font-size: 12px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #ffffff;
    }

    .Max-alter .party-branch .party-content-wrap .top-content-wrap {
        display: flex;
        justify-content: space-between;
        width: 100%;
        margin-bottom: 14px;
    }

    .Max-alter .party-branch .party-content-wrap .top-content-wrap .organizational-structure {
        width: 548px;
        height: 296px;
        background: rgba(9, 42, 102, 0.6);
        padding: 15px 21px;
        display: flex;
        flex-direction: column;
    }

    .Max-alter .party-branch .party-content-wrap .top-content-wrap .content-wrap1 {
        padding-top: 20px;
    }

    .Max-alter .party-branch .party-content-wrap .top-content-wrap .right-org-str {
        background: rgba(9, 42, 102, 0.6);
        padding: 15px 21px;
        display: flex;
        flex-direction: column;
        width: 485px;
        height: 296px;
    }

    .Max-alter .party-branch .party-content-wrap .top-content-wrap .right-org-str .content-wrap {
        height: 190px;
        width: 443px;
    }

    .Max-alter .party-branch .party-content-wrap .footer-content-bot {
        display: flex;
        justify-content: space-between;
    }

    .Max-alter .party-branch .party-content-wrap .footer-content-bot .footer-content-botL {
        width: 1148px;
        height: 192px;
        background: #092a66;
        opacity: 0.6;
        box-sizing: border-box;
        padding: 15px 30px;
        display: flex;
        flex-direction: column;
    }

    .Max-alter .party-branch .party-content-wrap .footer-content-bot .footer-content-botL .footer-content-wrap {
        display: flex;
        flex-grow: 1;
        align-items: center;
        justify-content: space-around;
    }

    .Max-alter .party-branch .party-content-wrap .footer-content-bot .footer-content-botL .footer-content-wrap .item-box {
        display: flex;
        flex-direction: column;
    }

    .Max-alter .party-branch .party-content-wrap .footer-content-bot .footer-content-botL .footer-content-wrap .item-box .top-info {
        font-size: 20px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #ffffff;
        line-height: 60px;
        opacity: 0.8;
    }

    .Max-alter .party-branch .party-content-wrap .footer-content-bot .footer-content-botL .footer-content-wrap .item-box .bot-num {
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .Max-alter .party-branch .party-content-wrap .footer-content-bot .footer-content-botL .footer-content-wrap .item-box .bot-num .left-user-num {
        font-size: 35px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #ffffff;
    }

    .Max-alter .party-branch .party-content-wrap .footer-content-bot .footer-content-botL .footer-content-wrap .item-box .bot-num .left-user-num span {
        color: #f7c25e;
    }

    .Max-alter .party-branch .party-content-wrap .footer-content-bot .footer-content-botR {
        width: 326px;
        height: 192px;
        background: #092a66;
        opacity: 0.6;
        padding: 15px 30px;
        box-sizing: border-box;
        display: flex;
        flex-direction: column;
    }

    .Max-alter .party-branch .party-content-wrap .footer-content-bot .footer-content-botR .peo-list {
        flex-grow: 1;
        display: flex;
        flex-direction: column;
    }

    .Max-alter .party-branch .party-content-wrap .footer-content-bot .footer-content-botR .peo-list .peo1-list {
        display: flex;
        justify-content: space-between;
        margin-top: 20px;
    }

    .Max-alter .party-branch .party-content-wrap .footer-content-bot .footer-content-botR .peo-list .peo1-list .tet {
        font-size: 18px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #ffffff;
        opacity: 0.8;
    }

    .Max-alter .party-branch .party-content-wrap .footer-content-bot .footer-content-botR .peo-list .peo1-list .tet-num {
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #ffffff;
    }

    .Max-alter .party-branch .party-content-wrap .footer-content-bot .footer-content-botR .peo-list .peo1-list .tet-num span {
        color: #f7c25e;
        font-size: 24px;
    }
</style>